import { BaseApiService } from '@services/baseApiService';
import { Appointment, AppointmentAvailability } from './types';
import { api } from '@services/api';
import { ApiError } from '@/types/api';

// Interface para o payload de criação de agendamento
export interface CreateSchedulePayload {
  appointmentId: string;
  date: string;
  filledFormId: string;
}

// Interface para a resposta da criação de agendamento
export interface ScheduleResponse {
  _id: string;
  appointmentId: string;
  date: string;
  filledFormId: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export class AppointmentService extends BaseApiService<Appointment> {
  constructor() {
    super('appointments');
  }

  async getAvailability(appointmentId: string): Promise<AppointmentAvailability> {
    const response = await api.request<AppointmentAvailability>(`${this.baseUrl}/${appointmentId}/full-availability`);
    if ('data' in response && response.data) {
      return response.data;
    }
    throw new Error('Falha ao obter disponibilidade de agendamento');
  }

  async createSchedule(payload: CreateSchedulePayload): Promise<ScheduleResponse> {
    const response = await api.request<ScheduleResponse>(`${this.baseUrl}/schedules`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if ('data' in response && response.data) {
      return response.data;
    }
    
    throw new Error('Falha ao criar agendamento');
  }

  // Você pode adicionar métodos específicos para Appointment aqui, se necessário
}

export const appointmentService = new AppointmentService(); 